// extracted by mini-css-extract-plugin
module.exports = {"status":"SupportCasesTable_status__2UL2f","actionButton":"SupportCasesTable_actionButton__2z-_B","nameLabel":"SupportCasesTable_nameLabel__17SFI"};